import { BulkPaymentRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useBulkWirePayment() {
  const [sendingBulkWirePayment, setSendingBulkWirePayment] = useState(false);

  async function sendBulkWirePayment(params: BulkPaymentRequest) {
    try {
      setSendingBulkWirePayment(true);
      const res = await api.bulkWirePayment(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setSendingBulkWirePayment(false);
    }
  }

  return { sendingBulkWirePayment, sendBulkWirePayment };
}
